module.exports = __webpack_public_path__ + "ar.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ar.svg
// module id = 422
// module chunks = 0